module.exports = __webpack_public_path__ + "static/media/check-accept.b3df9918.svg";